(function () {
  'use strict';
  if (window.omniPolicyPreferencesInitialized) return;
  window.omniPolicyPreferencesInitialized = true;

  function openPreferences() {
    if (window.Pandectes && typeof window.Pandectes.openDialog === 'function') {
      window.Pandectes.openDialog('preferences');
      return true;
    }
    return false;
  }

  var retryTimer;
  function requestPreferences(link) {
    window.clearTimeout(retryTimer);
    var attempts = 0;
    function attempt() {
      var status = document.getElementById('policy-cookie-status');
      try {
        if (openPreferences()) {
          if (status) status.remove();
          return;
        }
      } catch (error) {
        // The banner may expose its API before its dialog is ready.
      }
      if (++attempts < 40) {
        retryTimer = window.setTimeout(attempt, 250);
        return;
      }
      if (!link) return;
      if (!status) {
        status = document.createElement('span');
        status.id = 'policy-cookie-status';
        status.className = 'policy-cookie-status';
        status.setAttribute('role', 'status');
        link.parentNode.appendChild(status);
      }
      status.textContent = ' Cookie settings could not be opened. Please use the cookie icon in the corner. Your preferences have not been changed.';
    }
    attempt();
  }

  function openFromHash() {
    window.clearTimeout(retryTimer);
    if (window.location.hash === '#cookie-settings') requestPreferences();
  }
  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  // Capture before other theme/app handlers can stop link-click propagation.
  document.addEventListener('click', function (event) {
    var target = event.target.nodeType === 1 ? event.target : event.target.parentElement;
    var link = target && target.closest('a, [data-open-cookie-preferences]');
    if (!link) return;
    var isSettingsLink = link.hasAttribute('data-open-cookie-preferences');
    if (!isSettingsLink && link.href) {
      var url = new URL(link.href, window.location.href);
      isSettingsLink = url.origin === window.location.origin &&
        url.pathname === window.location.pathname && url.hash === '#cookie-settings';
    }
    if (!isSettingsLink) return;
    event.preventDefault();
    requestPreferences(link);
  }, true);
})();
